import { FC, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'

import WarningAlert from '../../atoms/WarningAlert'
import text from '../../../_constants/text'
import { useFeatureFlag } from '../../../hooks/useFeatureFlag'
import { FeatureFlagName } from '../../../_constants/featureFlags'
import urls from '../../../_constants/urls'

const MaintenanceModal: FC<{}> = () => {
  const featureFlagData = useFeatureFlag(FeatureFlagName.MAINTENANCE_MODAL)
  const [show, setShow] = useState(true)

  // Don't render anything while fetching feature flag or if flag is disabled
  if (!featureFlagData || !featureFlagData.enabled) {
    return null
  }

  const title = (featureFlagData?.title as string) || text.MAINTENANCE_MODAL_DEFAULT_TITLE
  const message1 = (featureFlagData?.message1 as string) || text.MAINTENANCE_MODAL_DEFAULT_MESSAGE_1
  const message2 = (featureFlagData?.message2 as string) || text.MAINTENANCE_MODAL_DEFAULT_MESSAGE_2(urls.IMED_IC_PACS)
  const showMessage2 = (featureFlagData?.showMessage2 as boolean) ?? true

  return (
    <Modal show={show} centered data-testid="maintenance-modal" size="lg">
      <Modal.Body>
        <div className="d-flex flex-column justify-content-center">
          <div className="d-flex flex-row align-items-center mb-3">
            <WarningAlert className="mt-4 ml-4" />
          </div>

          <h2 className="mt-3">{title}</h2>

          <p className="mt-3" dangerouslySetInnerHTML={{ __html: message1 }} />
          {showMessage2 && <p className="mt-3" dangerouslySetInnerHTML={{ __html: message2 }} />}

          <div className="d-flex flex-row justify-content-end">
            <Button className="mt-4" data-testid="maintenance-modal-close" onClick={() => setShow(false)}>
              {text.CLOSE}
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default MaintenanceModal
